<template>
  <div>
    <b-modal :active="isActivePopup" :on-cancel="closePopup" width="100%">
      <template v-if="popupContent >= 0">
        <CarouselModal v-if="modalType == 'carousel'"></CarouselModal>
        <LinksModal v-if="modalType == 'linkList'"></LinksModal>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

import CarouselModal from "@/components/modals/Carousel";
import LinksModal from "@/components/modals/Links";

export default {
  name: "ContentManager",
  components: { CarouselModal, LinksModal },
  data() {
    return {};
  },
  computed: {
    ...mapState(["popup", "popupContent", "content"]),

    isActivePopup() {
      //console.log(this.$store.state.popup > 0, this.$store.state.popup);
      return this.popup > 0;
    },
    modalType() {
      if (this.popupContent < 0) return null;
      return this.content[this.popupContent].modalType;
    },
  },
  methods: {
    onPopupClose() {},

    closePopup(val) {
      this.$store.dispatch("set_popup", 0);
    },
  },
};
</script>

<style scoped></style>
